import { useContext } from 'react';
import { UserContext } from '../context/UserProvider';

const useGetUser = () => useContext(UserContext);

export default useGetUser;
